export const education = [
    {
        speciality: "Computer Engineering",
        institution: "Odessa Technical College",
        link: "https://otfk.od.ua/",
        date: "September 2015 - July 2019",
        desc: [
            "Studied in the specialty \"Computer Engineering\".",
            "As a result of received the Diploma \"Junior Specialist\"."
        ]
    }
];